/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["input[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none}input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}.font-weight-normal-calibre[_ngcontent-%COMP%]{font-family:Calibre!important}"];
export { styles as styles };

